import { render, staticRenderFns } from "./LogoutCard.vue?vue&type=template&id=5d0fa5fb&"
import script from "./LogoutCard.vue?vue&type=script&lang=ts&"
export * from "./LogoutCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn})
